import styled from 'styled-components';

export const VisualMemoryScoresBox = styled.div`
    & * {
        font-size: 14px;
    }
`;